<script lang="ts">
	import type { OperationModel } from '@app/models/api/OperationModel';
	import { Social } from '@wiseed/wikit';
	import { capitalize } from '@wiseed/wikit';
	import { t } from 'svelte-i18n';
	import { undefOrNull } from '@wiseed/wikit';
	export let operation: OperationModel;

	let socialItems = [
		{
			iconName: 'world',
			url: operation.websiteUrl
		},
		{
			iconName: 'account',
			url: operation.societeComUrl
		},
		{
			iconName: 'facebook',
			url: operation.facebookUrl
		},
		{
			iconName: 'linkedin',
			url: operation.linkedInUrl
		},
		{
			iconName: 'instagram',
			url: operation.instagramUrl
		}
	];
</script>

{#if operation.websiteUrl || operation.facebookUrl || operation.linkedInUrl || operation.instagramUrl || operation.societeComUrl}
	<section>
		<h2>{capitalize($t('operation.social'))}</h2>
		<div class="flex gap-2">
			<Social
				items={socialItems.filter((e) => !!e && !undefOrNull(e.url) && !undefOrNull(e.iconName))}
			/>
		</div>
	</section>
{/if}
